import { store } from '@/store/store';
import { centros } from '@/shared/dtos/centros';
import {
    VuexModule,
    Mutation,
    getModule,
    Module,
    Action
} from 'vuex-module-decorators';
import { ssmHttpService } from '@/shared/services/http-service';
import { API } from '@/shared/api';

@Module({
    namespaced: true,
    name: 'centrosModule',
    store,
    dynamic: true
})
class centrosModule extends VuexModule {
    public centroses: centros[] = [];
    public centros: centros = new centros();

    @Action({ commit: 'onGetcentroses' })
    public async getcentroses() {
        return await ssmHttpService.get(API.centros);
    }

    @Action({ commit: 'onGetcentros' })
    public async getcentros(id: any) {
        return await ssmHttpService.get(API.centros + '/' + id);
    }

    @Action
    public async guardarcentros(centros: centros) {
        /*toJson() no existe pero existe en la extends de BaseDto*/
        return await ssmHttpService.post(API.centros, centros.toJson());
    }

    @Action
    public async enviar_ruta(centros: any) {
        /*toJson() no existe pero existe en la extends de BaseDto*/
        return await ssmHttpService.post(API.rutas, JSON.stringify(centros));
    }
    @Action
    public async Getcercanos(centros: any) {
        /*toJson() no existe pero existe en la extends de BaseDto*/
        return await ssmHttpService.post(API.rutas + '/cercanos', JSON.stringify(centros));
    }
    @Action
    public async GetCentroACentro(centros: any) {
        /*toJson() no existe pero existe en la extends de BaseDto*/
        return await ssmHttpService.post(API.rutas + '/centro-a-centro', JSON.stringify(centros));
    }
    @Action
    public async GetHotelesCercanos(centros: any) {
        /*toJson() no existe pero existe en la extends de BaseDto*/
        return await ssmHttpService.post(API.rutas + '/hoteles-cercanos', JSON.stringify(centros));
    }

    @Action
    public async obtenerRutaGoogle(centros: any) {
        /*toJson() no existe pero existe en la extends de BaseDto*/
        return await ssmHttpService.post(API.rutas + '/obtener-ruta-google', JSON.stringify(centros));
    }

    @Action
    public async GuardarRuta(centros: any) {
        /*toJson() no existe pero existe en la extends de BaseDto*/
        return await ssmHttpService.post(API.rutas + '/insertar-ruta', JSON.stringify(centros));
    }
    @Action
    public async UpdateRuta(centros: any) {
        /*toJson() no existe pero existe en la extends de BaseDto*/
        return await ssmHttpService.post(API.rutas + '/update-ruta', JSON.stringify(centros));
    }
    @Action
    public async GetRuta(id: any) {
        /*toJson() no existe pero existe en la extends de BaseDto*/
        return await ssmHttpService.get(API.rutas + '/ruta/' + id);
    }

    @Action
    public async ProgresoCalculoRutas() {
        /*toJson() no existe pero existe en la extends de BaseDto*/
        return await ssmHttpService.get(API.rutas + '/progreso/', null, false);
    }

    @Action
    public async IniciarProcesoCalculoRutas() {
        /*toJson() no existe pero existe en la extends de BaseDto*/
        return await ssmHttpService.get(API.rutas + '/iniciar-proceso/', null, false);
    }

    @Action
    public async ExportarExcelGuardado(id: number) {
        const response = await ssmHttpService.get(API.rutas + `/exportar-excel-openxml-guardado?id=${id}`, {
            responseType: 'blob',
        });
        let guid = 'planificacion_' + id;
        if (
            response &&
            response.planificacion &&
            response.planificacion.guid_generacion
        ) {
            guid = response.planificacion.guid_generacion;
        }
        const blob = new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `planificacion_${guid}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        return true;
    }


    @Action
    public async modificarcentros(centros: centros) {
        return await ssmHttpService.put(API.centros + '/' + centros.id, centros);
    }

    @Action
    public async eliminarcentros(centros: centros) {
        return await ssmHttpService.delete(API.centros + '/' + centros.id, null, false);
    }

    @Mutation
    public onGetcentroses(res: centros[]) {
        try {

            this.centroses = res ? res.map((x) => new centros(x)) : [];
        } catch (error) {

        }
    }

    @Mutation
    public onGetcentros(res: centros) {
        this.centros = new centros(res);
    }

}
export default getModule(centrosModule);